export const mutations = {
  setIsInboxHasAi($state, isInboxHasAi) {
    $state.isInboxHasAi = isInboxHasAi;
  },

  setIsChatAiHandover($state, isAiChatHandover) {
    $state.isAiChatHandover = isAiChatHandover;
  },

  setInboxAiName($state, inboxAiName) {
    $state.inboxAiName = inboxAiName;
  },

  setAiNests($state, aiNests) {
    $state.aiNests = aiNests;
  },

  clearAiNests($state) {
    $state.aiNests = [];
  },

  setChatbotUiFlags($state, uiFlags) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlags };
  },
};
